export class Rendered {
  private _rendered: string;
  
  constructor(data: any = null) {
    if (data) {
      this.normalize(data);
    }
  }  

  public normalize(data: any = null) {
    for (const prop in data) {
      if (! (data[prop] instanceof Object) && ! (data[prop] instanceof Array)) {
        this[prop] = data[prop];      
      }
    }
  }

  get rendered(): string {
    return this._rendered;
  }

  set rendered(value: string) {
    this._rendered = value;
  }
}
